import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";
import { Suspense } from "react";
import { Await, useRouteLoaderData } from "react-router-dom";

export default function CompetitorChartHeader({ sortConfig, requestSort, radioIds }) {
    const { competitorRadios } = useRouteLoaderData("root");

    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs={3} xl onClick={requestSort ? () => requestSort("artist") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-start">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={3} xl onClick={requestSort ? () => requestSort("title") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-start">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("release_year") : null} className=" align-self-center px-xl-2">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Release Year</span>
                        <span className="col-1">{renderSortIcon("release_year", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("spins") : null} className=" align-self-center px-xl-2">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Market Spins</span>
                        <span className="col-1">{renderSortIcon("spins", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("average_spins") : null} className=" align-self-center px-xl-2">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Avg. Spins</span>
                        <span className="col-1">{renderSortIcon("average_spins", sortConfig)}</span>
                    </Stack>
                </Col>
                {radioIds.map((x, i) => (
                    <Col key={x} xs xl={1} onClick={requestSort ? () => requestSort(`radio_spins[${i}].spins`) : null} className=" align-self-center px-xl-2">
                        <Stack direction="horizontal" className="justify-content-center">
                            <span className="offset-1 text-center ">
                                <Suspense>
                                    <Await resolve={competitorRadios}>
                                        {resolvedRadios => resolvedRadios.data.find(rr => rr.radio_id === x)?.radio_name ?? "Unknown"}
                                    </Await>
                                </Suspense>
                            </span>
                            <span className="col-1">{renderSortIcon(`radio_spins[${i}].spins`, sortConfig)}</span>
                        </Stack>
                    </Col>
                ))}
                <Col xs={1} className=" align-self-center text-center px-0 d-none d-xl-block">
                    Market Trend
                </Col>
            </Row>
        </Container>
    );
}
